import { useState, useEffect } from 'react';

import { isBuildTime } from '@powdr/utils';

export const useWindowResize = (callback) => {
  const [windowResize, setWindowResize] = useState({
    windowWidth: undefined,
    windowHeight: undefined,
  });

  if (isBuildTime()) return windowResize;

  useEffect(() => {
    const handleResize = () => {
      setWindowResize({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
      });
      if (typeof callback === 'function') callback();
    };

    handleResize();

    const debounceResize = setTimeout(() => {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, 250);

    return () => clearTimeout(debounceResize);
  }, [callback]);

  return windowResize;
};
